/**
 * Email Utilities
 *
 * Helpers for validating email addresses.
 *
 * @module utils/email
 */

/**
 * Validates email format.
 * Checks that the email contains @ and has a domain part.
 *
 * @param email - The email address to validate
 * @returns True if the email format is valid
 */
export function isValidEmail(email: string): boolean {
  if (!email || !email.trim()) {
    return false;
  }

  // Basic validation: contains @ and has something before and after
  const trimmed = email.trim();
  const atIndex = trimmed.indexOf('@');

  // Must have @ somewhere in the middle
  if (atIndex <= 0 || atIndex === trimmed.length - 1) {
    return false;
  }

  // Must have a domain part with at least one character after @
  const domainPart = trimmed.slice(atIndex + 1);
  if (!domainPart || domainPart.length === 0) {
    return false;
  }

  // Domain must contain at least one dot for a valid TLD
  if (!domainPart.includes('.')) {
    return false;
  }

  // Domain must not start or end with a dot
  if (domainPart.startsWith('.') || domainPart.endsWith('.')) {
    return false;
  }

  return true;
}
